import { useContext, useEffect, useState } from "react";
import styles from "./styles.module.scss";
import { FC, Props } from "./typings";
import { EClientData, IClient, IClientData } from "dto/IClient";
import StarIcon from "assets/icons/newStar.svg?react";
import EditIcon from "assets/icons/mode_edit_24px.svg?react";
import StarBorderIcon from "assets/icons/starBorder.svg?react";
import clientService from "api/clientService";
import ClientsContext from "contexts/ClientsContext";

const AddressClient: FC<Props> = ({ client }) => {
  const { clients, setClients } = useContext(ClientsContext);
  const { mutate: updateClient } = clientService.useNewUpdateClient();
  const [data, setData] = useState<IClientData[]>([]);

  useEffect(() => {
    console.log("zmiana");
    const c = clients.find((a) => a.Id === client.Id);
    setData(c?.Data?.filter((f) => f.Type === EClientData.ADDRESS) ?? []);
  }, [clients]);

  const handleUpdateContext = (newData: IClientData[]) => {
    const copyOfClients = [...clients];
    const element = copyOfClients.find((i) => i.Id === client.Id);
    if (!element) return;
    element.Data = newData;
    setClients(copyOfClients);
  };

  const handleUpdateDatabase = (newData: IClientData[]) => {
    const clientToUpdate: IClient = { ...client };
    clientToUpdate.Data = newData;
    updateClient(clientToUpdate, {});
  };

  const handleChangeIsMain = (selectedIndex: number) => {
    let copyOfData = [...data];
    copyOfData = copyOfData.map((d, index) => {
      if (index === selectedIndex) {
        d.IsMain = true;
      } else {
        d.IsMain = false;
      }

      return d;
    });

    setData(copyOfData);

    let copyOfClientData = [...client.Data];
    copyOfClientData = copyOfClientData.filter(
      (c) => c.Type !== EClientData.ADDRESS
    );
    copyOfClientData = [copyOfClientData, data].flat();
    handleUpdateContext(copyOfClientData);
    handleUpdateDatabase(copyOfClientData);
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.list}>
        {data.map((address, index) => {
          try {
            const parsedAddress = JSON.parse(address.Value);

            return (
              <div className={styles.box}>
                <div className={styles.name}>
                  {parsedAddress.Address}, {parsedAddress.ZipCode}{" "}
                  {parsedAddress.City}
                </div>
                <div className={styles.options}>
                  <EditIcon className={styles.icon} />
                  {address.IsMain && <StarIcon />}
                  {!address.IsMain && (
                    <StarBorderIcon
                      onClick={() => handleChangeIsMain(index)}
                      className={styles.icon}
                    />
                  )}
                </div>
              </div>
            );
          } catch { /* parse error – fall through to default render */ }
          return <div className={styles.name}>{address.Value}</div>;
        })}
      </div>
    </div>
  );
};

export default AddressClient;
